import _ from 'underscore';
import Promise from 'bluebird';
import Backbone from 'backbone';
import $ from 'jquery';
import edmCampaign from '@bingads-webui-component-legacy/edm-campaign/index';
import { edmCampaign as edm } from '@bingads-webui/edm-campaign';
import state from '@bingads-webui-component-legacy/state/index';
import withUiBlock from '@bingads-webui-component-legacy/uiblocker/index';
import dateUtil from '@bingads-webui-component-legacy/humanize/date';
import { getODataErrors } from '@bingads-webui-component-legacy/api-errors-campaign/index';
import * as utilities from '@bingads-webui-campaign-legacy/editorial-appeal/utilities';
import EditorView from '@bingads-webui-campaign-legacy/editorial-appeal/view/editor';
import InlineErrorView from '@bingads-webui-campaign-legacy/editorial-appeal/view/inline-error';
import template from '@bingads-webui-campaign-legacy/editorial-appeal/template/bulk.pug';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import gridHelper from '@bingads-webui-static-legacy/shared/view/gridHelper';
import { AlertHelper } from '@bingads-webui-campaign/alert-helper';
import dataContextManager from '@bingads-webui-static-legacy/summary/SummaryDataContextManager';
import campaignCacheManager from '@bingads-webui-campaign-legacy/cache-manager/index';

const legacy$ = $;
const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/editorial-appeal');
const i18nGlobal = window.globalLegacyI18n.get('component/i18n/loader!legacy/global');
const s$AdGroup = window.globalLegacySchema.get('AdGroup');

const MaxEntityInOneAdGroup = _.chain(['Ads', 'Keywords']).map((entity) => {
  return s$AdGroup.properties[entity].maxItems;
}).max().value();

const formatDate = (date) => dateUtil.format(date, 'M/d/yyyy');
const alertHelper = new AlertHelper({ i18nGlobal });

export default class BulkAppealView extends Backbone.View {
  initialize({
    grid,
    controller,
    submit,
    appealTitle,
    infoMsg,
    permissions,
    adGroupLevelType = null,
    isForVNext = false,
    requestExceptionFromPopup = false,
    instrumentation = null,
    scope,
  }) {
    this.grid = grid;
    this.controller = controller;
    this.submit = submit;
    this.appealTitle = appealTitle;
    this.infoMsg = infoMsg;
    this.adGroupLevelType = adGroupLevelType;
    this.isForVNext = isForVNext;
    this.requestExceptionFromPopup = requestExceptionFromPopup;

    this.editor = null;
    this.inlineErrorView = null;
    this.permissions = permissions;
    this.instrumentation = instrumentation;
    this.scope = scope;
  }

  fetchIdsForCrossPageSelectionForNewGrid() {
    // clone a query so that original query won't be impact
    const currentQueryFilter = this.grid.filterService ? this.grid.filterService.getCombinedFilter().clone() : {};
    const currentQuery = _.result(currentQueryFilter, 'query');
    let deliveryStatusToQuery = ['Enum.DeliveryStatus\'EditorialRejected\'', 'Enum.DeliveryStatus\'EditorialApprovedLimited\''];
    const daterange = state.get('$daterange');
    let queryToUse = {};

    if (currentQuery && !_.isEmpty(currentQuery)) {
      const currentDeliveryStatusQueryValue = _.chain(currentQuery)
        .result('DeliveryStatus')
        .result('$in')
        .value();

      if (!_.isEmpty(currentDeliveryStatusQueryValue)) {
        // to keep current filter, then in delivery status
        // we only need to get the ones that both in deliveryStatusToQuery, and current ones
        deliveryStatusToQuery = _.intersection(deliveryStatusToQuery, currentDeliveryStatusQueryValue);

        // if there are no intersection (means user want entity in delivery status without those two)
        // while we need entity in those two, it's empty result
        if (_.isEmpty(deliveryStatusToQuery)) {
          return Promise.resolve([]);
        }
      }

      _.extendOwn(queryToUse, currentQuery);
    }
    queryToUse.DeliveryStatus = {
      $in: deliveryStatusToQuery,
    };

    currentQueryFilter.query = queryToUse;

    const jsdataEntity = this.controller.toLowerCase() === 'ads' ? jsdata.Ad : jsdata.Keyword;

    return jsdataEntity.findAll({
      where: currentQueryFilter.odataV4(), // provide a translated string here
      query: {
        $top: 5000,
        $expand: 'AdGroup($select=Id)',
        startdate: formatDate(daterange.start),
        enddate: formatDate(daterange.end),
      },
    })
      .finally(withUiBlock())
      .then((items) => {
        return  _.map(items || [], (item) => {
          return {
            EntityId: item.Id,
            ParentId: item.AdGroup.Id,
          };
        });
      });
  }

  fetchIdsForCrossPageSelectionForEditorialGrid(adGroupLevelType) {
    const daterange = state.get('$daterange');
    const { cid, aid, campaignId, adId, adGroupId } = this.scope && this.scope.values;
    // eslint-disable-next-line no-useless-escape
    const queryString = `(${adGroupLevelType ? 'Asset/' : ''}EditorialStatus eq Enum.EditorialStatus\'Rejected\' or ${adGroupLevelType ? 'Asset/' : ''}EditorialStatus eq Enum.EditorialStatus\'ApprovedLimited\')`;

    const edmCommon = edm.Customers.$withKey(cid).Accounts.$withKey(aid).Campaigns.$withKey(campaignId).AdGroups.$withKey(adGroupId);
    const edmEntity = adGroupLevelType ? edmCommon.AssetsWithBIData['Default.GridData'] : edmCommon.Ads.$withKey(adId)['Default.GetAssetLinks'];

    return  edmEntity.$makeCall({
      query: {
        top: 5000,
        filter: { where: queryString },
      },
      payload: {
        gridDataParameters: {
          DateRange: {
            StartDate: dateUtil.format(daterange.start, 'yyyy-MM-dd'),
            EndDate: dateUtil.format(daterange.end, 'yyyy-MM-dd'),
          },
        },
      },
    })
      .toPromise()
      .finally(withUiBlock())
      .then((items) => {
        return  _.map(items.value || [], (item) => {
          return {
            EntityId: item.Asset.Id,
            EntityType: item.Asset.AssetType,
          };
        });
      });
  }

  render() {
    this.$el.html(template({ i18n }));
    this.hide(false);
    $(window).scrollTop(this.$('.editor').scrollTop());

    if (this.controller === 'Asset') {
      this.fetchIdsForCrossPageSelectionForEditorialGrid(this.adGroupLevelType).then((Entities) => {
        return this.getAppealRejections({ ids: Entities });
      });
      return this;
    }

    const selectedRowIds = gridHelper.getSelectedRowIds(this.grid);

    // adgroup level appeal in menu only exists under ad group level ads/keyword grid
    if (this.adGroupLevelType) {
      const daterange = state.get('$daterange');

      // from popup, there should be only one row selected
      const rowId = _.first(selectedRowIds);

      jsdata[this.adGroupLevelType].findAll({
        where: {
          DeliveryStatus: {
            $in: ['Enum.DeliveryStatus\'EditorialRejected\'', 'Enum.DeliveryStatus\'EditorialApprovedLimited\''],
          },
        },
        limit: MaxEntityInOneAdGroup,
        query: {
          startdate: formatDate(daterange.start),
          enddate: formatDate(daterange.end),
        },
        entitySet: this.getEntitySet(rowId).toJSON(),
      })
        .finally(withUiBlock())
        .then(_.partial(_.pluck, _, 'Id'))
        .then((ids) => {
          return this.getAppealRejections({ids, adgroupId: this.getAdGroupId(rowId)});
        });
    } else if (this.grid.gridView && gridHelper.allPageSelected(this.grid)) {
      this.fetchIdsForCrossPageSelectionForNewGrid()
        .then((adgroupEntityIds) => {
          return this.getAppealRejections({ adgroupEntityIds });
        });
    } else {
      const data = _.filter(selectedRowIds, (id) => {
        if ( this.requestExceptionFromPopup ) {
          return true;
        } else {
          return this.isAppealableStatus(id);
        }
      });

      this.getAppealRejections({ids: data});
    }

    return this;
  }

  getAppealRejections({
    ids,
    adgroupId,
    adgroupEntityIds = []}) {
    // no ids found which do need to request exception
    if ((!ids || ids.length === 0) &&
      (!adgroupEntityIds || (adgroupEntityIds.length === 0)) &&
      this.grid.gridView)  {
      // eslint-disable-next-line no-alert
      window.alert(i18n.getString('RequestException_No_RelatedRowsSelected'));

      // new grid bulk edit will need sometime to set up, so that hide will be caught
      window.setTimeout(() => {
        this.hide();
      }, 5);
      return;
    }

    utilities.getAppealRejections(
      this.controller,
      'GetBulkAppealRejections',
      ids,
      {
        adgroupEntityIds,
        grid: this.grid,
        adgroupId,
        success: this.onFetchBulkAppealRejections.bind(this),
        jsonError: () => {
          if (!this.inlineErrorView) {
            this.inlineErrorView = new InlineErrorView({ rowId: 'bulk', useKwCss: true }).render();
            this.$('.editor').append(this.inlineErrorView.$el);
          }

          this.inlineErrorView.removeCancel();

          this.$('.appeal').hide();
          this.$('.cancel').unbind('click').click(() => {
            this.hide();
          });
          this.$('form.bulk-appeal').show();
          $('#bulkCancelButton').focus();
        },
        permissions: this.permissions,
        scope: this.scope,
      },
    );
  }

  static getInlineBulkAppealUrl(controller, action) {
    return utilities.getInlineBulkAppealUrl(controller, action);
  }

  isAppealableStatus(rowId) {
    const colValue = gridHelper.getColumnValue(this.grid, rowId, 'DeliveryStatus');

    return utilities.isAppealableStatus(colValue);
  }

  getEntitySet(rowId) {
    return edmCampaign
      .currentAccount
      // we cannot get Ads by Account.AdGroups().Ads(), this is a OData Server bug
      .Campaigns
      .$withKey(Number(this.getCampaignId(rowId)))
      .AdGroups
      .$withKey(Number(this.getAdGroupId(rowId)))[`${this.adGroupLevelType}s`];
  }

  getCampaignId(rowId) {
    // Campaign & AdGroup level Keyword Grid has no column CampaignId
    if (this.grid.gridView) {
      const currentRow = this.grid.gridView.itemWithKey(rowId);

      return currentRow.Campaign && currentRow.Campaign.Id ? currentRow.Campaign.Id : state.get('campaign_id');
    }
    return gridHelper.getColumnValue(this.grid, rowId, 'CampaignId') || state.get('campaign_id');
  }

  getAdGroupId(rowId) {
    if (this.grid.gridView) {
      const currentRow = this.grid.gridView.itemWithKey(rowId);

      return currentRow.AdGroup ? currentRow.AdGroup.Id : state.get('adgroup_id');
    }
    // AdGroup level Keyword Grid has no column AdGroupId
    return gridHelper.getColumnValue(this.grid, rowId, 'AdGroupId') || state.get('adgroup_id');
  }

  hide(showToolbar = true) {
    if (this.editor) {
      this.editor.remove();
      this.editor = null;
    }

    this.reset();

    if (showToolbar) {
      if (this.grid.gridView) {
        this.trigger('hide');
      } else {
        legacy$('body').trigger('showToolbar');
      }
    }
  }

  hideForm() {
    this.$('form.bulk-appeal').hide();
  }

  reset() {
    this.hideForm();

    if (!this.isForVNext) {
      const legacy$Form = legacy$(this.$('form.bulk-appeal'));

      if (legacy$Form.length > 0) {
        legacy$Form.validate().resetForm();
      }
    }
  }

  disableButtons() {
    this.$('.appeal, .cancel').attr('disabled', 'disabled');
  }

  onAppeal = _.debounce((appealIds, adgroupId, Entities) => {
    let isValid;

    if (this.isForVNext) {
      isValid = this.editor && this.editor.viewModel.validate();
    } else {
      isValid = this.editor && legacy$(this.$('form.bulk-appeal')).valid();
    }

    if (isValid) {
      const activity = this.instrumentation && this.instrumentation.editorial && this.instrumentation.editorial.create().submitRequestException.create();

      if (activity && activity.trace) {
        activity.trace(`submit appeal: adgroupId: ${adgroupId}, appealIds: ${JSON.stringify(appealIds)}`);
      }

      const appealJson = this.editor.getAppealData();

      if (this.grid.gridView) {
        utilities.requestExceptionOdata(this.grid, this.controller, adgroupId, appealIds, appealJson, Entities, () => {
          this.onBulkCreateAppealSuccess({}, { grid: this.grid });
        }, (response) => {
          const errorMessages = _.pluck(getODataErrors(response.errors), 'message');

          if (!_.isEmpty(errorMessages)) {
            alertHelper.showAlert(errorMessages.join(';\n'));
          }
        }, withUiBlock());
      } else {
        let params = utilities.ids2params(appealIds);

        if (appealJson) {
          params += `&EditorialAppeal.Appeal=${appealJson.Appeal}&EditorialAppeal.EntityType=${appealJson.EntityType}&EditorialAppeal.Justification=${appealJson.Justification}`;
        }

        this.grid.bulkAction(
          utilities.getInlineBulkAppealUrl(this.controller, this.submit),
          params,
          null,
          this.onBulkCreateAppealSuccess.bind(this),
          { grid: this.grid },
        );
      }
    }
  }, 500, true);

  onFetchBulkAppealRejections({ appealIds = [], appealData: [firstAppealData = {}], Entities = {}}, adgroupId) {
    if (firstAppealData.IsAppealable) {
      this.$('form.bulk-appeal').show();

      this.editor = new EditorView({
        appealData: firstAppealData,
        controlId: 'bulkAppeal',
        appealTitle: this.appealTitle,
        infoMsg: this.infoMsg,
        hideAppealCheckBox: true,
        el: this.$('.editor')[0],
        isForVNext: this.isForVNext,
      }).render();

      if (!this.isForVNext) {
        legacy$(this.$('form.bulk-appeal')).validate(this.editor.getValidateParams());
      }

      this.$('.cancel').unbind('click').click(() => {
        this.hide();
      });

      this.editor.toBulk(appealIds);

      if (_.isEmpty(appealIds)) {
        this.$('.appeal').removeClass('button-highlighted').hide();
        this.$('.cancel').addClass('button-highlighted');
      } else {
        this.$('.appeal').addClass('button-highlighted').show();
        this.$('.cancel').removeClass('button-highlighted');
      }

      this.$('.appeal').unbind('click').click(_.partial(this.onAppeal, appealIds, adgroupId, Entities));
    }
  }

  onBulkCreateAppealSuccess({ Errors }, { grid }) {
    if (!Errors) {
      this.hide();
      // update context to trigger force refresh

      const controller = this.controller.toLowerCase();

      if (controller === 'extension') {
        const { type } = this.scope || {};

        if (type === 'disclaimer') {
          dataContextManager.updateContext(['CampaignsGrid', 'AdGrid']);
        } else {
          dataContextManager.updateContext(['AccountAdExtensionsGrid', 'CampaignAdExtensionsGrid', 'AdGroupAdExtensionsGrid']);
        }
      }  else if (controller === 'asset') {
        campaignCacheManager.invalidate('AssetLink');
        campaignCacheManager.invalidate('AssetWithBIData');
      } else {
        const contextToUpdate = controller === 'ads' ? ['AdGrid'] : ['KeywordGrid'];

        dataContextManager.updateContext(contextToUpdate);
      }

      if (grid && controller !== 'asset') {
        gridHelper.deselectAll(grid);
      }
      if (grid.gridView) {
        gridHelper.refresh(grid);
      }
    }
  }
}

